export default __webpack_public_path__ + "static/media/IF_MyStrengths_FullProfile_Desc_11.52f52412.jpg";